var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { buildSearchEngine, getSampleSearchEngineConfiguration, } from '@coveo/headless';
import React, { useEffect, useRef } from 'react';
import { AtomicSearchInterface } from './stencil-generated/index';
const DefaultProps = {
    onReady: (executeFirstSearch) => {
        return executeFirstSearch();
    },
    localization: () => { },
};
/**
 * This component serves as a wrapper for the core AtomicSearchInterface.
 * @param props
 * @returns
 */
export const SearchInterfaceWrapper = (props) => {
    const mergedProps = Object.assign(Object.assign({}, DefaultProps), props);
    if (!mergedProps.engine) {
        mergedProps.engine = buildSearchEngine({
            configuration: getSampleSearchEngineConfiguration(),
        });
    }
    const { engine, localization, onReady } = mergedProps, allOtherProps = __rest(mergedProps, ["engine", "localization", "onReady"]);
    const searchInterfaceRef = useRef(null);
    let initialization = null;
    useEffect(() => {
        const searchInterfaceAtomic = searchInterfaceRef.current;
        if (!initialization) {
            initialization = searchInterfaceAtomic.initializeWithSearchEngine(engine);
            initialization.then(() => {
                localization(searchInterfaceAtomic.i18n);
                onReady(searchInterfaceAtomic.executeFirstSearch.bind(searchInterfaceAtomic));
            });
        }
    }, [searchInterfaceRef]);
    return (React.createElement(AtomicSearchInterface, Object.assign({ ref: searchInterfaceRef }, allOtherProps), props.children));
};
//# sourceMappingURL=SearchInterfaceWrapper.js.map